function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 19v.525c0 .417-.142.767-.425 1.05-.283.283-.642.425-1.075.425-.417 0-.77-.146-1.063-.438A1.447 1.447 0 013 19.5V12l2.1-6c.1-.3.28-.542.538-.725C5.896 5.092 6.183 5 6.5 5h11c.317 0 .604.092.863.275.258.183.437.425.537.725l2.1 6v7.525c0 .417-.142.767-.425 1.05-.283.283-.642.425-1.075.425-.417 0-.77-.146-1.063-.438A1.446 1.446 0 0118 19.5V19H6zm-.2-9h12.4l-1.05-3H6.85L5.8 10zm1.7 6c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 007.5 13c-.417 0-.77.146-1.063.438A1.447 1.447 0 006 14.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437zm9 0c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 0016.5 13c-.417 0-.77.146-1.063.438A1.446 1.446 0 0015 14.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437z",
    fill: "#292A2B"
  })));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-car-option.svg";